import { format } from 'date-fns'
import { create } from 'zustand'

import { rangeOptions } from '../components/DateRangeSelect/utilities'
import { AdvancedFiltersState } from '../features/DetailedReport/components/AdvancedFilters/AdvancedFilters.models'

import { Domain } from 'Types/Domain'

interface BMState {
  domains: Domain[]
  chosenDomains: Domain[] | null
  dateRange: {
    fromDate: string
    toDate: string
  }
  searchQuery: string
  advancedFilters: AdvancedFiltersState | null
  hasFetchedDomains: boolean
  setDomains: (domains: Domain[]) => void
  setChosenDomains: (domains: Domain[] | null) => void
  setDateRange: (from: Date, to: Date) => void
  setSearchQuery: (query: string) => void
  setAdvancedFilters: (filters: AdvancedFiltersState) => void
  setHasFetchedDomains: (fetched: boolean) => void
}

const weekRange = rangeOptions.WEEK.range

export const useBMStore = create<BMState>((set) => ({
  domains: [],
  chosenDomains: null,
  dateRange: {
    fromDate: weekRange ? format(weekRange.from as Date, 'yyyy-MM-dd') : '',
    toDate: weekRange ? format(weekRange.to as Date, 'yyyy-MM-dd') : '',
  },
  searchQuery: '',
  advancedFilters: null,
  hasFetchedDomains: false,
  setDomains: (domains: Domain[]) => set(() => ({ domains })),
  setChosenDomains: (domains: Domain[] | null) => set(() => ({ chosenDomains: domains })),
  setDateRange: (from: Date, to: Date) =>
    set(() => ({
      dateRange: {
        fromDate: format(from, 'yyyy-MM-dd'),
        toDate: format(to, 'yyyy-MM-dd'),
      },
    })),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setAdvancedFilters: (filters) => set({ advancedFilters: filters }),
  setHasFetchedDomains: (fetched: boolean) => set({ hasFetchedDomains: fetched }),
}))
